import { useState, useEffect } from 'react';
import { motion } from 'framer-motion';

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 20);
    window.addEventListener('scroll', onScroll);
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  return (
    <motion.nav
      data-testid="navbar"
      initial={{ y: -10, opacity: 0 }}
      animate={{ y: 0, opacity: 1 }}
      transition={{ duration: 0.5 }}
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        scrolled
          ? 'bg-[#FAFAF7]/95 backdrop-blur-xl border-b border-[#0A1628]/8 shadow-sm'
          : 'bg-transparent'
      }`}
    >
      <div className="max-w-7xl mx-auto px-6 lg:px-10 py-4 flex items-center justify-between">
        <a href="#" data-testid="navbar-logo" className="font-black text-2xl tracking-tighter text-[#0A1628]">
          Althera Group
        </a>
        <a
          href="#book"
          data-testid="navbar-cta"
          className="bg-[#00D4B8] text-[#0A1628] font-semibold text-sm px-5 py-2.5 rounded-xl hover:bg-[#00D4B8]/90 hover:scale-[1.03] transition-all duration-200 shadow-sm"
        >
          Book a call
        </a>
      </div>
    </motion.nav>
  );
}
